module.exports = __webpack_public_path__ + "img/pin_substitution_blue.75c05c01.svg";